export default [
  {
    title: 'Dashboards',
    route: 'dashboard-users',
    icon: 'HomeIcon',
    action: 'read',
    resource: 'dashboard',
  },
]
